import { Link } from 'react-router'
import styles from './JobListEmpty.module.css'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { links } from '@/utils/link'
import { byDesign } from '@/infra/design'
import imgSearchNoresultsUrl from '@/assets/misc/img_search-noresults.svg'
import SearchNoResultsIllustration from '@/components/SpotIllustration/SearchNoResultsIllustration'
import imgNoJobsUrl from '@/assets/misc/img_no-jobs.svg'
import NoJobsIllustration from '@/components/SpotIllustration/NoJobsIllustration'

export interface JobListEmptyProps {
  wasSearching: boolean
  canViewOpportunities: boolean
  corporateMode: boolean
}

export function JobListEmpty({
  wasSearching,
  canViewOpportunities,
  corporateMode,
}: JobListEmptyProps) {
  return (
    <EmptyState size="sm" pad>
      {!corporateMode && (
        <EmptyStateIllustration
          src={wasSearching ? imgSearchNoresultsUrl : imgNoJobsUrl}
          illustration={byDesign(
            undefined,
            wasSearching ? SearchNoResultsIllustration : NoJobsIllustration,
          )}
          alt=""
        />
      )}
      <EmptyStateTitle>
        {wasSearching ? 'We looked everywhere...' : 'No active jobs.'}
      </EmptyStateTitle>
      <EmptyStateDescription>
        {wasSearching ? (
          <>But we couldn't find any active jobs matching your search.</>
        ) : canViewOpportunities ? (
          <>
            Ready for more? Head on over to{' '}
            <Link className={styles.link} to={links.opportunities()}>
              opportunities
            </Link>{' '}
            and see what's available!
          </>
        ) : (
          <>Active jobs will be shown here!</>
        )}
      </EmptyStateDescription>
    </EmptyState>
  )
}
